const commonActionTypes = {
  SET_TEST_COMMON: 'SET_TEST_COMMON',
  SET_CONTEXT: 'SET_CONTEXT',
  FETCH_CONFIGURATIONS: 'FETCH_CONFIGURATIONS',
  FETCH_CONFIGURATIONS_SUCCESS: 'FETCH_CONFIGURATIONS_SUCCESS',
  FETCH_CONFIGURATIONS_FAIL: 'FETCH_CONFIGURATIONS_FAIL',
};

export default commonActionTypes;
